import React, {useContext, useEffect, useState} from 'react';
import {FormOperacionCorporateLendingDetalle, schemaFormOperacionCorporateLendingDetalle} from "../types/types";
import {useForm} from "react-hook-form";
import {zodResolver} from "@hookform/resolvers/zod";
import {useDetalle} from "../hooks/useDetalle";
import CorporateLendingDetalle from "./CorporateLendingDetalle";
import {HttpCorporateLending} from "../api/httpCorporateLending";
import toast from "react-hot-toast";
import {OperacionCorporateLendingDetalleFields} from "../types/fields";
import CorporateLendingDetalleForm from "./CorporateLendingDetalleForm";
import {ContextOperacion, ContextOperacionType} from "../../../RefactorLayout";
import {QueryStatus} from "../../../../../types";
import CircularProgress from "@mui/material/CircularProgress";

interface SeccionCorporateLendingDetalleProps {
  codPais: number,
  operacionId: number,
}

function SeccionCorporateLendingDetalle({codPais, operacionId}: SeccionCorporateLendingDetalleProps) {
  const {permisoTipo} = useContext<ContextOperacionType>(ContextOperacion)

  const [openDialog, setOpenDialog] = useState<boolean>(false);

  const {detalle, status, refetch} = useDetalle(operacionId);

  const formMethods = useForm<FormOperacionCorporateLendingDetalle>({
    resolver: zodResolver(schemaFormOperacionCorporateLendingDetalle),
  });

  useEffect(() => {
    if (detalle) {
      formMethods.reset({...detalle});
    }
  }, [detalle, formMethods]);

  const alGuardarDetalle = (data: FormOperacionCorporateLendingDetalle) => {
    const promise = HttpCorporateLending.putDetalle(operacionId, data.id, data);

    toast
      .promise(promise, {
        loading: 'Guardando',
        success: 'Guardado correctamente',
        error: 'Error al guardar'
      })
      .then(() => {
        refetch();
        setOpenDialog(false);
      });
  };

  return (

    <>
      {
        status === QueryStatus.Loading
          ? <CircularProgress disableShrink sx={{mt: 6}}/>
          : (detalle?.[OperacionCorporateLendingDetalleFields.PermiteEditar] && permisoTipo > 1) ?
            <CorporateLendingDetalleForm codPais={codPais} formMethods={formMethods} onSubmitForm={alGuardarDetalle}
                                         detalle={detalle}/>
            : <CorporateLendingDetalle detalle={detalle}/>

      }
    </>
  );
}

export default SeccionCorporateLendingDetalle;